import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';

import queryString from 'query-string';

import StockNotification from 'components/Account/Profile/StockNotification/StockNotification';

import { Storage } from 'services/Storage';

import { compose } from 'util/hocs';
import { loadable } from 'util/loadable';
import { isEmpty } from 'util/utils';

import { commonLogout, IS_QUICK_SEARCH } from 'constants/Common';

const App = loadable(() => import('../App'));
const Account = loadable(() => import('components/Account'));
const ChangePassword = loadable(() => import('components/Account/ChangePassword'));
const CompanyInformation = loadable(() => import('components/Account/CompanyInformation'));
const DiamondColumnListing = loadable(() => import('components/Account/ManageDiamondSequence'));
const MobileAccount = loadable(() => import('components/Account/MobileAccount'));
const PersonalInformation = loadable(() => import('components/Account/PersonalInformation'));
const Dashboard = loadable(() => import('components/Dashboard'));
const Compare = loadable(() => import('components/DiamondCompare'));
const DiamondList = loadable(() => import('components/DiamondList'));
const BidList = loadable(() => import('components/DiamondList/BidList'));
const MyDemand = loadable(() => import('components/MyDemand/'));
const NewArrivalBidIt = loadable(() => import('components/NewArrivalBidIt'));
const Notifications = loadable(() => import('components/Notifications'));
const Offer = loadable(() => import('components/Offer'));
const PrivacyNotice = loadable(() => import('components/PrivacyNotice'));
const QuickSearch = loadable(() => import('components/QuickSearch'));
const SavedSearch = loadable(() => import('components/SavedSearch'));
const TrackShipment = loadable(() => import('components/TrackShipment'));
const NotificationDropdown = loadable(() => import('components/common/Header/NotificationDropdown'));
const DiamondSearch = loadable(() => import('containers/DiamondSearch'));

class Routes extends Component {
  redirectPage = () => {
    const path = this.props.location.pathname.split('/').pop();
    const USER_PERMIT = Storage.get('userPermissions');

    if (isEmpty(USER_PERMIT)) commonLogout();

    if (path === 'device') {
      const values = queryString.parse(this.props.location.search);
      if (values && values.token) Storage.set('token', values.token);
    }
    const isTrusted = Storage.get('isTrusted', false);
    const isLoggedInUser = Storage.get('token');

    if (isLoggedInUser && isLoggedInUser.length && isTrusted === 'false') {
      return <Redirect to="/verify-otp" />;
    } else if (!isLoggedInUser || !isLoggedInUser.length) {
      return <Redirect to="/signin" />;
    }
  };

  render() {
    const P = Storage.get('userPermissions');
    const isMobile = window.innerWidth <= 767;

    return (
      <App>
        <Switch>
          {this.redirectPage()}
          {P?.FANCY_SEARCH?.view && <Route exact path="/fancy-search/:id?" component={DiamondSearch} />}
          {P?.SEARCH_DIAMOND?.view && <Route exact path="/diamond-search/:id?" component={DiamondSearch} />}
          {P?.MATCH_PAIR?.view && <Route exact path="/search-match-pair/:id?" component={DiamondSearch} />}
          <Route exact path="/search-bid-diamond/:id?" component={DiamondSearch} />
          {P?.EXCLUSIVE?.view && <Route exact path="/exclusive/:id?" component={DiamondList} />}
          {P?.MATCH_PAIR?.view && <Route exact path="/match-pair/:id?" component={DiamondList} />}
          {P?.BID_MODULE?.view && <Route exact path="/new-arrival-bid-it/:id?" component={NewArrivalBidIt} />}
          {P?.QUOTE_DAY?.view && <Route exact path="/quote-day/:id?" component={DiamondList} />}
          {P?.SEARCH_LIST?.view && <Route exact path="/diamond-list/:id?" component={DiamondList} />}
          {P?.STONE_OF_THE_DAY?.view && <Route exact path="/stone-of-the-day/:id?" component={DiamondList} />}
          {P?.SUGGESTED_STOCK?.view && <Route exact path="/suggested-stock/:id?" component={DiamondList} />}
          {P?.UPCOMING?.view && <Route exact path="/upcoming/:id?" component={DiamondList} />}
          {P?.UPCOMING?.view && <Route exact path="/new-arrivals" component={DiamondList} />}
          <Route exact path="/collection/:id?" component={DiamondList} />
          <Route exact path="/deal-of-the-day/:id?" component={DiamondList} />
          <Route exact path="/my-bid/:id?" component={BidList} />
          {P?.COMPARE?.view && <Route exact path="/compare" component={Compare} />}
          {P?.DASHBOARD?.view && <Route exact path="/dashboard" component={Dashboard} />}
          {P?.DEMAND?.view && isMobile && <Route exact path="/account/my-demand" component={MyDemand} />}
          {P?.QUICK_SEARCH?.view && IS_QUICK_SEARCH && <Route exact path="/quick-search" component={QuickSearch} />}
          {P?.SAVE_SEARCH?.view && isMobile && <Route exact path="/account/saved-search" component={SavedSearch} />}
          {P?.SHIPMENT?.view && isMobile && <Route exact path="/account/my-shipment" component={MyDemand} />}
          <Route exact path="/account" component={isMobile ? MobileAccount : Account} />
          {isMobile && <Route exact path="/account/change-password" component={ChangePassword} />}
          {isMobile && <Route exact path="/account/company-profile" component={CompanyInformation} />}
          {isMobile && <Route exact path="/account/personal-information" component={PersonalInformation} />}
          {isMobile && <Route exact path="/account/stock-notification" component={StockNotification} />}
          {isMobile && <Route exact path="/notification" component={NotificationDropdown} />}
          {P?.CART?.view && <Route exact path="/account/cart" component={isMobile ? DiamondList : Account} />}
          {P?.BUY_REQUEST?.view && (
            <Route exact path="/account/buy-request" component={isMobile ? DiamondList : Account} />
          )}
          {P?.CONFIRM_STONE?.view && (
            <Route exact path="/account/confirm-list" component={isMobile ? DiamondList : Account} />
          )}
          {P?.DEMAND?.view && <Route exact path="/account/my-demand" component={Account} />}
          {P?.ENQUIRY?.view && <Route exact path="/account/enquiry" component={Account} />}
          {P?.HOLD?.view && <Route exact path="/account/hold" component={isMobile ? DiamondList : Account} />}
          {P?.MEMO?.view && <Route exact path="/account/memo" component={isMobile ? DiamondList : Account} />}
          {P?.NOTES?.view && <Route exact path="/account/notes" component={isMobile ? DiamondList : Account} />}
          {P?.NOTIFICATIONS?.view && <Route exact path="/notifications" component={Notifications} />}
          {P?.OFFICE?.view && <Route exact path="/account/office-list" component={isMobile ? DiamondList : Account} />}
          {P?.QUOTE?.view && <Route exact path="/account/offer-list" component={isMobile ? Offer : Account} />}
          {P?.REMINDER?.view && <Route exact path="/account/reminder" component={Account} />}
          {P?.SAVE_SEARCH?.view && <Route exact path="/account/saved-search" component={Account} />}
          {P?.SHIPMENT?.view && <Route exact path="/account/my-shipment" component={Account} />}
          {P?.WATCHLIST?.view && <Route exact path="/account/watchlist" component={isMobile ? DiamondList : Account} />}
          {/* <Route exact path="/account/my-seen-stones" component={Account} /> */}

          <Route exact path="/account/profile" component={Account} />
          <Route exact path="/account/profile/diamond-sequence" component={isMobile ? DiamondColumnListing : Account} />

          <Route exact path="/privacy-notice" component={PrivacyNotice} />
          <Route exact path="/track-diamond" component={TrackShipment} />
          {/* <Route exact path="/account/profile/manage-user" component={Account} /> */}
          {/* <Route exact path="/account/profile/manage-address" component={Account} /> */}
          {/* <Route exact path="/diamond-detail/:id" component={DiamondDetail} /> */}
          <Redirect from="*" to="/not-found" />
        </Switch>
      </App>
    );
  }
}

export default compose(
  connect((store) => ({
    store: store,
  })),
  withRouter,
)(Routes);
